import { mapDtoToModel } from './mappers';

export { clientService } from './client-service';
export const ClientMappers = { mapDtoToModel };
export type { ClientDto } from './types';
